import { FC, ReactNode } from "react";
import styled from "styled-components";

const StyledDrawerBody = styled.div`
  padding: 32px;
`;

interface Props {
  children?: ReactNode;
  className?: string;
}

const DrawerBody: FC<Props> = ({ className, children }) => {
  return <StyledDrawerBody className={className}>{children}</StyledDrawerBody>;
};

export { DrawerBody };
